let styles = {
  btn: {
    flex: 1
  },
  btnBar: {
    width: "100%",
  },
  btnText: {
    textTransform: "none",
    fontWeight: "bold"
  }
};

export default styles;